import { createApi } from '@reduxjs/toolkit/query/react'
import { aesKey, API_ENDPOINTS, iv } from 'Constants'
import { ILeadListingRequest, IUpdateLifeLeadRequest } from 'Models/RequestModels/LMS'
import { ILeadListing } from 'Models/ResponseModels/Life'
import { bobLmsUrlQuery } from 'Services/baseQuery'
import { decryptMessage } from 'Utils'

interface ICreateLeadRequest {
  customer_uid: string
  branch_sol_id: string
  first_name: string
  last_name: string
  phone_number: string
  email: string
  lead_assign_to_username: string
  lead_generator_username: string
  lead_stage: string
  product: string
  lead_source: string
  lead_journey_data: any
}

export interface ILeadDashboardAnalytics {
  total_leads?: number
  products?: {
    product: 'HEALTH'|'FIRE'|'MOTOR'|'LIFE'|'BGR'|'TRAVEL',
    products_count: number
    meta: {
      lead_state: string
      lead_state_count: number
      this_week: number
      last_week: number
      week_changes: number
     }[]
    this_week_date_range: string[][]
    last_week_date_range: string[]
  }[]
  lead_stage?: {
    lead_stage: string
    lead_stage_count: number
  }[]
  lead_source?: {
    lead_source: string
    lead_source_count: number
  }[]
  lead_state?: {
    lead_state: string
    lead_state_count: number
  }[]
  encrypted_data?: string
  date_wise_leads?: {
    count: number
    date: string
  }[]
  revenue?: {
    aggregate_amount: number
  }
}

export const bobLmsApi = createApi({
  reducerPath: 'bobLmsUrlQuery',
  baseQuery: bobLmsUrlQuery,
  endpoints: (builder) => ({
    createLead: builder.mutation<{encrypted_data:string}, {data?:string,is_encrypted?:number}>({
      query: (body) => ({
        url: API_ENDPOINTS.BOB.LMS_CREATE_LEAD,
        method: 'POST',
        body: body,
      }),
    }),
    updateLead: builder.mutation<{encrypted_data:string}, {data?:string,is_encrypted?:number}>({
      query: (body) => ({
        url: API_ENDPOINTS.BOB.LMS_UPDATE_LEAD,
        method: 'POST',
        body: body,
      }),
    }),
    getLeadListing: builder.query<{encrypted_data:string}, {data?:string,is_encrypted?:number}>({
      query: (params) => ({
        url: API_ENDPOINTS.BOB.LMS_GET_LEAD_LISTING,
        method: 'GET',
        params: params,
      }),
    }),

    getLeadAnalytics: builder.mutation<ILeadDashboardAnalytics, { data?: string, is_encrypted?: number }>({
      query: (body) => ({
        url: API_ENDPOINTS.BOB.LMS_GET_LEAD_ANALYTICS,
        method: 'POST',
        body: body,
      }),
      transformErrorResponse: async(response: { decrypted_data: string }) => {
          const decryptedRes = await decryptMessage(response.decrypted_data, aesKey, iv)
          return decryptedRes.decryptedData
        
      }
    }),
    getLeadCount: builder.mutation<{
      total_leads: number,
      open_leads: number,
      closed_leads: number,
      converted_leads: number
      lead_generator_count: number,
      active_branch_count: number,
      total_users_count: number,
      total_branch_count: number
    }, {
      zone_name?: string,
      region_name?: string,
      branch_sol_id_list?: string[],
      from_date?: string,
      to_date?: string
      product_type?: string
    }>({
      query: (body) => ({
        url: API_ENDPOINTS.BOB.LEAD_COUNT,
        method: 'POST',
        body: body,
      }),
      transformResponse: async (response:any) => { 
        if (Array.isArray(response)) { 
          return response[0]
        } else {
          return response
        }
      }
    })
  }),
})

export const { useCreateLeadMutation, useUpdateLeadMutation, useLazyGetLeadListingQuery, useGetLeadAnalyticsMutation,useGetLeadCountMutation } =
  bobLmsApi
